import { render } from "./MaterialVendorStockTable.vue?vue&type=template&id=0049b22a"
import script from "./MaterialVendorStockTable.vue?vue&type=script&lang=js"
export * from "./MaterialVendorStockTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__